/* unplugin-vue-components disabled */import script from "./systemMessageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./systemMessageDialog.vue?vue&type=script&setup=true&lang=js"

import "./systemMessageDialog.vue?vue&type=style&index=0&id=1091e210&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/frontend_prod_master@2/project/wfzx-platform-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1091e210"]])

export default __exports__